// Hostnames that should swap in
// relative links when possible.
const RELATIVE_LINK_HOSTNAMES = [
  'new.smm.org',
];

const constructRelativeLink = (url) => {
  try {
    const targetURL = new URL(url);

    if (RELATIVE_LINK_HOSTNAMES.includes(targetURL.hostname)) {
      // Use pathname as relative link
      return targetURL.pathname;
    }
  } catch (e) {
    return url;
  }
  return url;
};

export default constructRelativeLink;
